import { render, staticRenderFns } from "./NetMargin.vue?vue&type=template&id=03cf4415"
import script from "./NetMargin.vue?vue&type=script&lang=js"
export * from "./NetMargin.vue?vue&type=script&lang=js"
import style0 from "./NetMargin.vue?vue&type=style&index=0&id=03cf4415&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports